// Task status configuration
export const TASK_STATUS = {
  BACKLOG: 'backlog',
  TODO: 'todo',
  IN_PROGRESS: 'progress',
  IN_REVIEW: 'review',
  DONE: 'done',
};

export const STATUS_CONFIG = {
  [TASK_STATUS.BACKLOG]: {
    label: 'Backlog',
    color: '#64748b',
    bg: '#f1f5f9',
  },
  [TASK_STATUS.TODO]: {
    label: 'Por Hacer',
    color: '#3b82f6',
    bg: '#dbeafe',
  },
  [TASK_STATUS.IN_PROGRESS]: {
    label: 'En Progreso',
    color: '#f59e0b',
    bg: '#fef3c7',
  },
  [TASK_STATUS.IN_REVIEW]: {
    label: 'En Revisión',
    color: '#8b5cf6',
    bg: '#ede9fe',
  },
  [TASK_STATUS.DONE]: {
    label: 'Completado',
    color: '#10b981',
    bg: '#d1fae5',
  },
};

// Priority configuration
export const TASK_PRIORITY = {
  CRITICAL: 'critical',
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
};

export const PRIORITY_CONFIG = {
  [TASK_PRIORITY.CRITICAL]: {
    label: 'Crítica',
    color: '#dc2626',
    icon: '🔴',
  },
  [TASK_PRIORITY.HIGH]: {
    label: 'Alta',
    color: '#f97316',
    icon: '🟠',
  },
  [TASK_PRIORITY.MEDIUM]: {
    label: 'Media',
    color: '#eab308',
    icon: '🟡',
  },
  [TASK_PRIORITY.LOW]: {
    label: 'Baja',
    color: '#22c55e',
    icon: '🟢',
  },
};

// Task type configuration
export const TASK_TYPE = {
  FEATURE: 'feature',
  BUG: 'bug',
  IMPROVEMENT: 'improvement',
  TASK: 'task',
};

export const TYPE_CONFIG = {
  [TASK_TYPE.FEATURE]: {
    label: 'Feature',
    color: '#3b82f6',
    icon: '✨',
  },
  [TASK_TYPE.BUG]: {
    label: 'Bug',
    color: '#ef4444',
    icon: '🐛',
  },
  [TASK_TYPE.IMPROVEMENT]: {
    label: 'Mejora',
    color: '#8b5cf6',
    icon: '⚡',
  },
  [TASK_TYPE.TASK]: {
    label: 'Tarea',
    color: '#64748b',
    icon: '📋',
  },
};

// User roles
export const USER_ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  DEVELOPER: 'developer',
  CLIENT: 'client',
};

export const ROLE_CONFIG = {
  [USER_ROLES.ADMIN]: {
    label: 'Administrador',
    permissions: ['all'],
  },
  [USER_ROLES.MANAGER]: {
    label: 'Project Manager',
    permissions: ['projects', 'tasks', 'sprints', 'team', 'reports'],
  },
  [USER_ROLES.DEVELOPER]: {
    label: 'Desarrollador',
    permissions: ['tasks', 'sprints'],
  },
  [USER_ROLES.CLIENT]: {
    label: 'Cliente',
    permissions: ['view_progress'],
  },
};

// Sprint status
export const SPRINT_STATUS = {
  PLANNED: 'planned',
  ACTIVE: 'active',
  COMPLETED: 'completed',
};

// Story points (Fibonacci)
export const STORY_POINTS = [1, 2, 3, 5, 8, 13, 21];

// Menu items for sidebar con permisos requeridos
export const MENU_ITEMS = [
  { id: 'dashboard', icon: '📊', label: 'Dashboard', permissions: [] }, // Acceso para todos
  { id: 'kanban', icon: '📋', label: 'Kanban', permissions: ['tareas.ver'] },
  { id: 'sprints', icon: '🏃', label: 'Sprints', permissions: ['sprints.ver'] },
  { id: 'roadmap', icon: '🗺️', label: 'Roadmap', permissions: ['epics.ver'] },
  { id: 'calendar', icon: '📅', label: 'Calendario', permissions: ['tareas.ver'] },
  { id: 'meetings', icon: '🎙️', label: 'Reuniones', permissions: ['tareas.crear'] },
  { id: 'team', icon: '👥', label: 'Equipo', permissions: ['equipo.ver'] },
  { id: 'metrics', icon: '📈', label: 'Métricas', permissions: ['reportes.ver'] },
];

// Permisos para la página de configuración
export const SETTINGS_PERMISSIONS = ['configuracion.ver'];
